<template>
    <button
        type="button"
        value="Delete"
        class="xsbtn btn-danger"
    >
    <i class="fa-solid fa-trash"></i>
    Delete
    </button>
</template>